/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Human review state of a chronology event
 */
export type ChronologyReviewStatus = typeof ChronologyReviewStatus[keyof typeof ChronologyReviewStatus];


export const ChronologyReviewStatus = {
  UNREVIEWED: 'UNREVIEWED',
  CONFIRMED: 'CONFIRMED',
  CORRECTED: 'CORRECTED',
  REJECTED: 'REJECTED',
} as const;
